export const QUERY_PARAM = {
  tag: 't',
  query: 'q'
}
